export default __webpack_public_path__ + "static/media/metamask-setup_image_7.8a962c3b.jpg";